import { getUrlObject } from '@carboncopyco/editor-utils';
import { TextBase } from '@carboncopyco/ui';
import Highlighter from 'react-highlight-words';
import { RulePreview } from '../../../RulePreview';

export interface TransactionUrlProps {
  url: string;
  searchValue?: string;
}

export const TransactionUrl = ({ url, searchValue }: TransactionUrlProps) => {
  const { pathname, href } = getUrlObject(url) ?? {};

  return (
    <RulePreview.Tooltip
      title={href}
      appendTo={() => document.body}
    >
      <span className="truncate">
        <TextBase
          label={
            <Highlighter
              highlightClassName="ds-code-editor-highlight"
              searchWords={[searchValue]}
              textToHighlight={pathname}
              autoEscape
            />
          }
          color="text-ds-natural-600"
          ellipsis
        />
      </span>
    </RulePreview.Tooltip>
  );
};
